<template>
  <div class="form-range">
    <div class="range-slider">
      <input
        class="input-range"
        orient="vertical"
        type="range"
        :step="step"
        :min="min"
        :max="max"
        v-model="computedValue"
      />
      <span class="range-value"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormRange",
  props: {
    value: Number,
    properties: Object
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", Number(value));
      }
    },
    min() {
      return this.properties.min || 0;
    },
    max() {
      return this.properties.max || 100;
    },
    step() {
      return this.properties.step || 5;
    }
  }
};
</script>

<style lang="scss">
.range-slider {
  // Slider
  .input-range {
    -webkit-appearance: none;
    height: 200px;
    border-radius: 5px;
    background: #ccc;
    outline: none;
    writing-mode: bt-lr; /* IE */
    -webkit-appearance: slider-vertical; /* WebKit */
  }
}

// Firefox Overrides
::-moz-range-track {
  background: #ccc;
  border: 0;
}

input::-moz-focus-inner {
  border: 0;
}
</style>
